export type Income = {
  hasBusinessIncome: boolean;
  hasMiscellaneousIncome: boolean;
  hasDividendIncome: boolean;
  hasRealEstateIncome: boolean;
  hasRetirementIncome: boolean;
  hasOtherIncome: boolean;
};

export type Schema = {
  income: Income;
};

export const generateDefaultValues = (income: Income): Schema => {
  return {
    income: {
      hasBusinessIncome: income?.hasBusinessIncome,
      hasMiscellaneousIncome: income?.hasMiscellaneousIncome,
      hasDividendIncome: income?.hasDividendIncome,
      hasRealEstateIncome: income?.hasRealEstateIncome,
      hasRetirementIncome: income?.hasRetirementIncome,
      hasOtherIncome: income?.hasOtherIncome
    }
  };
};
